import { render, staticRenderFns } from "./apidocs.vue?vue&type=template&id=2b85d6db&scoped=true"
import script from "./apidocs.vue?vue&type=script&lang=js"
export * from "./apidocs.vue?vue&type=script&lang=js"
import style0 from "./apidocs.vue?vue&type=style&index=0&id=2b85d6db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85d6db",
  null
  
)

export default component.exports